"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const AutocompleteContext_1 = require("./AutocompleteContext");
const AutocompleteMoreButton_1 = __importDefault(require("./AutocompleteMoreButton"));
function AutocompletePagination(props) {
    var _a, _b;
    const { loader: customLoader, children } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    const { pageNumber = 0, resultsTotal = 0, resultsPerPage = 0 } = (ctx.page ||
        {});
    const leftToLoad = resultsTotal ? resultsTotal - ctx.suggestions.length : 0;
    const resultsExpected = leftToLoad < (resultsPerPage || 0) ? leftToLoad : resultsPerPage;
    const loader = customLoader || (() => t('common:loading'));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ctx.loading ? loader(resultsExpected) : null,
        typeof children === 'function' ? children(ctx) : null,
        !ctx.loading &&
            ((_a = ctx.page) === null || _a === void 0 ? void 0 : _a.resultsTotal) &&
            ((_b = ctx.page) === null || _b === void 0 ? void 0 : _b.resultsTotal) > ctx.suggestions.length &&
            ctx.pageNumberExpected === pageNumber ? (react_1.default.createElement(AutocompleteMoreButton_1.default, { withoutWrapper: props.withoutWrapper })) : null));
}
exports.default = AutocompletePagination;
//# sourceMappingURL=AutocompletePagination.js.map